import { render, staticRenderFns } from "./ProgramadoAtendidoListFiltro.vue?vue&type=template&id=23869c50"
import script from "./ProgramadoAtendidoListFiltro.vue?vue&type=script&lang=js"
export * from "./ProgramadoAtendidoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports